import { Link } from "react-router-dom";
import { useEffect, useState } from "react";
import { Logo } from "./Header";
import { http } from "../lib/api";
import { FooterCatalog } from "./CatalogMenu";
import { WebshopKeurmerk } from './WebshopKeurmerk';
import { openCookieSettings } from '../lib/consent';

const info = [["bedrijfsgegevens", "Bedrijfsgegevens"], ["contact", "Contact"], ["verzending", "Verzending & levering"], ["betalen", "Betalen"],
  ["garantie", "Garantie"], ["retourneren", "Retourneren & herroeping"], ["privacy", "Privacy"], ["cookies", "Cookies"], ["voorwaarden", "Algemene voorwaarden"]];

function NextLevelNetwork() {
  const [n, setN] = useState(null);
  useEffect(() => { http.get("/site").then((r) => setN(r.data.network)).catch(() => {}); }, []);
  if (!n?.links?.length) return null;
  return (
    <div className="border-t border-white/10" data-testid="footer-network">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12 py-12">
        <p className="eyebrow mb-6">{n.title || "Ook van Next Level"}</p>
        <ul className="grid gap-8 sm:grid-cols-2 lg:grid-cols-4">
          {n.links.map((l, i) => (
            <li key={l.name}>
              <a href={l.url} target="_blank" rel="noopener" className="group block" data-testid={`footer-network-link-${i}`}>
                <span className="font-serif-brand text-lg text-white group-hover:text-[#B78B7B] transition-colors">{l.name}</span>
                <span className="block text-sm text-[#B9B3AA] mt-2 leading-relaxed">{l.text}</span>
              </a>
            </li>))}
        </ul>
      </div>
    </div>);
}

export default function Footer() {
  return (
    <footer className="bg-[#272D30] text-[#E9E4DD] mt-24">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12 py-16 grid gap-12 md:grid-cols-4">
        <div className="md:col-span-1">
          <Logo />
          <p className="text-sm text-[#B9B3AA] mt-6 leading-relaxed">Vloeren & interieur.<br />Een webshop van Next Level, Wormerveer.</p>
          <div className="mt-6" data-testid="footer-keurmerk"><WebshopKeurmerk prefix="footer" /></div>
        </div>
        <div>
          <p className="eyebrow mb-4">Assortiment</p>
          <FooterCatalog />
        </div>
        <div className="md:col-span-2">
          <p className="eyebrow mb-4">Klantinformatie</p>
          <ul className="grid grid-cols-2 gap-2 text-sm">
            {info.map(([s, l]) => <li key={s}><Link to={`/info/${s}`} data-testid={`footer-link-${s}`} className="hover:text-white">{l}</Link></li>)}
            <li><button type="button" onClick={openCookieSettings} data-testid="footer-cookie-settings" className="underline hover:text-white">Cookie-instellingen</button></li>
          </ul>
        </div>
      </div>
      <NextLevelNetwork />
      <div className="border-t border-white/10 text-xs text-[#9A948B] py-6 text-center">© {new Date().getFullYear()} VLOVER by Next Level</div>
    </footer>
  );
}

export { CookieBanner } from './CookieConsent';
